
import { Injectable } from '@angular/core';
import { NetworkService } from './shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class InitialServiceService {


  constructor(private networkService: NetworkService,
    ) { }

  loadProject() {
    return this.networkService.get("api/project", null, null, null);
  }

}


// nbstrn.plexome.com      production
// webuat.plexome.com      uat